module.exports = __webpack_public_path__ + "img/spravki-e1505229854410-300x186.759c1614.png";